import React from 'react';
import ProductForm from '../components/admin/ProductForm';

const AdminProductFormPage = () => {
  return (
    <div className="container">
      <ProductForm />
    </div>
  );
};

export default AdminProductFormPage;